// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-space-module--container--5m2Q7"};